import { LoadTenderExpressEdiStopGrid } from "../LoadTenderExpressEdiStopGrid";
import { DataSource, HorizontalSpacer, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLoadTenderExpressExpanded extends Layout {
    horizontalspacer1: HorizontalSpacer;
    labelBatch: Label;
    labelBatchNumber: Label;
    labelCreateDate: Label;
    labelCreated: Label;
    labelDetails: Label;
    labelFAStatus: Label;
    labelFuncAckNumber: Label;
    labelGs06GroupCntlno: Label;
    labelLabel1: Label;
    labelLabel5: Label;
    labelMoveStatus: Label;
    labelOrderType: Label;
    labelPalletNumber: Label;
    labelPallets: Label;
    labelPreload: Label;
    labelPreloadedLabel: Label;
    labelPreloadedTrailer: Label;
    labelTractorType: Label;
    labelTrailerId: Label;
    label_: Label;
    layoutLoadTenderExpressEdiStopGrid: LoadTenderExpressEdiStopGrid;
    panelBrkStatus: Panel;
    panelHeader: Panel;
    panelPurposeSwap: Panel;
    sourceEdiOrder: DataSource;
    sourceEdiStop: DataSource;
    textboxBrkStatus: Textbox;
}
